<template>
  <el-table-column :label="label" :prop="prop" class-name="paid-flights" :sortable="sortable" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '有償飛行件数'
    },
    prop: {
      type: String,
      default: 'paid_flights'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  td,
  th {
    &.paid-flights {
      width: 10em;
    }
  }
  td.paid-flights {
    text-align: center;
  }
}
</style>
